const accessPermission = "ACCESS_CONFIGURATION|COMPANY_SETTING";
const updatePermission = "UPDATE_CONFIGURATION|COMPANY_SETTING";

export const PERMISSIONS_CONFIG = {
    'appearance': {
        'ACCESS': `${accessPermission}|THEME`,
        'VISIBLE': false,
        'UPDATE': `${updatePermission}|THEME`,
        'CREATE': false
    }
};
